module.exports = __webpack_public_path__ + "static/media/els-top-logo.e283dcd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/els-top-logo.png
// module id = 200
// module chunks = 0